module.exports = __webpack_public_path__ + "img/20191112152619360截图20191112151539205.c95e6aeb.jpg";